// Wallet panel: Kal coin balance, calling number and recent activity.
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { describeLedgerReason, formatICN } from '../lib/kaltiq.js';

const fmt = n => Number(n).toLocaleString();

export default class AccWalletView extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {loading: true, wallet: null, ledger: [], error: null};
    this.refresh = this.refresh.bind(this);
  }

  componentDidMount() {
    this._mounted = true;
    this.refresh();
  }

  componentWillUnmount() {
    this._mounted = false;
  }

  async refresh() {
    this.setState({loading: true, error: null});
    try {
      const [wallet, ledger] = await Promise.all([this.props.kaltiq.wallet(), this.props.kaltiq.ledger(20)]);
      if (this._mounted) {
        this.setState({wallet, ledger, loading: false});
      }
    } catch (err) {
      if (this._mounted) {
        this.setState({loading: false, error: err.message});
      }
    }
  }

  render() {
    const {wallet, ledger, loading, error} = this.state;
    const pricing = wallet ? wallet.pricing : null;
    const icn = wallet ? wallet.icn : null;

    return (
      <div className="scrollable-panel kq-panel">
        <div className="panel-form-column">
          <a href="#" className="flat-button float-right" onClick={e => {e.preventDefault(); this.refresh();}}>
            <i className="material-icons">refresh</i>&nbsp;
            <FormattedMessage id="kq_refresh" defaultMessage="Refresh" description="KalTiQ: reload wallet" />
          </a>
          <div className="kq-balance">
            <label className="small">
              <FormattedMessage id="kq_balance" defaultMessage="Kal coins" description="KalTiQ: wallet balance label" />
            </label>
            <div className="kq-balance-value" aria-live="polite">{wallet ? fmt(wallet.balance) : (loading ? '…' : '—')}</div>
          </div>
          <div className="dialog-buttons kq-actions">
            <button type="button" className="primary" onClick={() => this.props.onNavigate('pay')}>Pay a Business</button>
            <button type="button" className="primary" onClick={() => this.props.onNavigate('crypto')}>Buy or redeem with USDT</button>
          </div>
          {error ? <div className="kq-error" role="alert">{error}</div> : null}
        </div>

        <div className="hr" />
        <div className="panel-form-column">
          <label className="small">
            <FormattedMessage id="kq_my_number" defaultMessage="Your calling number" description="KalTiQ: user's 12-digit number" />
          </label>
          {icn ?
            <div className="kq-number-card">
              <tt className="kq-number">{formatICN(icn.number)}</tt>
              <span className={'kq-tier kq-tier-' + icn.tier}>{icn.tier}</span>
            </div>
            :
            <div className="kq-muted">
              <FormattedMessage id="kq_no_number" defaultMessage="You don't have a number yet."
                description="KalTiQ: shown when the user has no 12-digit number" />
            </div>}
          <div className="dialog-buttons kq-actions">
            <button type="button" className="primary" onClick={() => this.props.onNavigate('number')}>
              {icn ?
                <FormattedMessage id="kq_change_number" defaultMessage="Change number" description="KalTiQ: button" /> :
                <FormattedMessage id="kq_choose_number" defaultMessage="Choose your number" description="KalTiQ: button" />}
            </button>
          </div>
        </div>

        {pricing ?
          <React.Fragment>
            <div className="hr" />
            <div className="panel-form-column">
              <label className="small">
                <FormattedMessage id="kq_prices" defaultMessage="Prices" description="KalTiQ: price list heading" />
              </label>
              <table className="kq-prices"><tbody>
                <tr><td><FormattedMessage id="kq_price_username" defaultMessage="Username" description="KalTiQ: price row" /></td><td>{fmt(pricing.username_price)}</td></tr>
                <tr><td><FormattedMessage id="kq_price_general" defaultMessage="General number" description="KalTiQ: price row" /></td><td>{fmt(pricing.general_price)}</td></tr>
                <tr><td><FormattedMessage id="kq_price_vanity" defaultMessage="Vanity number" description="KalTiQ: price row" /></td><td>{fmt(pricing.vanity_price)}</td></tr>
                <tr><td><FormattedMessage id="kq_price_premium" defaultMessage="Premium number" description="KalTiQ: price row" /></td><td>{fmt(pricing.premium_min)}+</td></tr>
              </tbody></table>
            </div>
          </React.Fragment> : null}

        <div className="hr" />
        <div className="panel-form-column">
          <label className="small">
            <FormattedMessage id="kq_activity" defaultMessage="Recent activity" description="KalTiQ: ledger heading" />
          </label>
          {ledger.length == 0 && !loading ?
            <div className="kq-muted">
              <FormattedMessage id="kq_no_activity" defaultMessage="No transactions yet." description="KalTiQ: empty ledger" />
            </div> : null}
          <ul className="kq-ledger">
            {ledger.map(e => (
              <li key={e.id}>
                <div>
                  <div>{describeLedgerReason(e.reason)}{/^\d{12}$/.test(e.ref || '') ? <tt className="kq-ref"> {formatICN(e.ref)}</tt> : null}</div>
                  <div className="kq-muted small">{new Date(e.created_at).toLocaleString()}</div>
                </div>
                <div className={e.delta > 0 ? 'kq-pos' : 'kq-neg'}>{e.delta > 0 ? '+' : '−'}{fmt(Math.abs(e.delta))}</div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    );
  }
};
